var exports = {
  "kL": "xa15a2ab7--4cea4e--container",
  "su": "xa15a2ab7--4cea4e--icon-wrapper",
  "Kk": "xa15a2ab7--4cea4e--icon",
  "h_": "xa15a2ab7--4cea4e--description",
  "DD": "xa15a2ab7--4cea4e--title",
  "VA": "xa15a2ab7--4cea4e--subtitle",
};

module.exports = exports;
